export const LIMITED_PERMISSION_CODE = [90112052]
